export function getActStatusLabel(status: string, t: (key: string) => string): string {
  const keyMap: Record<string, string> = {
    draft: "calculations.status.draft",
    signing_pending: "calculations.status.signingPending",
    pending_signing: "calculations.status.pendingSigning",
    signed: "calculations.status.signed",
    approved: "calculations.status.approved",
    rejected: "calculations.status.rejected",
    revoked: "calculations.status.revoked",
    cancelled: "calculations.status.cancelled",
    pending_review: "calculations.status.pendingReview",
  };
  return t(keyMap[status] ?? "calculations.status.unknown");
}

